import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAzureSubscriptionsDayMeasures } from "./finops-azure-subscriptions.model";
import { DateGranularityEnum } from "src/app/shared/enum/date-granularity.enum";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAzureSubscriptionsService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    loadFinOpsAzureSubscriptionsHistoricalData(granularity: DateGranularityEnum, date: string) {
        return this.httpClient.get<FinOpsAzureSubscriptionsDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/subscriptions?date=${date}&granularity=${granularity}`)
    }

    loadFinOpsAzureSubscriptionsMeasures(date: string) {
        return this.httpClient.get<FinOpsAzureSubscriptionsDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/subscriptions/measures?date=${date}`)
    }

}
